import { useState } from 'react';
import type { Software } from '@/types/software';
import { platformIcons } from '@/utils/catalog';

export default function DownloadPanel({ item }: { item: Software }) {
  const [toast, setToast] = useState('');

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(''), 2600);
  };

  const handleDownload = (platform: string) => {
    showToast(`正在为 ${platform} 准备「${item.name} ${item.version}」下载包…（演示）`);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(item.downloadUrl);
      showToast('下载链接已复制到剪贴板');
    } catch {
      showToast(`下载链接：${item.downloadUrl}`);
    }
  };

  return (
    <section id="download-panel" className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950">
          <i className="ri-download-cloud-2-line text-primary-600"></i>下载地址
        </h2>
        <span className="rounded-md bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800">
          当前版本 {item.version}
        </span>
      </div>

      <p className="mb-4 text-sm leading-relaxed text-foreground-500">
        请根据你的设备系统选择合适的下载包。以下下载均为演示，不会触发真实文件传输。
      </p>

      <div className="mb-4 flex flex-wrap gap-3">
        {item.platforms.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => handleDownload(p)}
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className={`${platformIcons[p]} text-base`}></i>
            下载 {p} 版
          </button>
        ))}
        <button
          type="button"
          onClick={handleCopy}
          className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-link"></i>复制下载链接
        </button>
      </div>

      <div className="flex items-start gap-2 rounded-md bg-background-100 p-3 text-xs leading-relaxed text-foreground-500">
        <i className="ri-information-line mt-0.5 text-sm text-accent-600"></i>
        <span className="break-all">文件地址：{item.downloadUrl}</span>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-[70] -translate-x-1/2 rounded-md bg-primary-800 px-5 py-3 text-sm text-background-50 shadow-sm kp-fade-up">
          <span className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-accent-400"></i>
            {toast}
          </span>
        </div>
      )}
    </section>
  );
}